import { Group, PasswordInput as MantinePasswordInput, Stack, Switch, TextInput } from '@mantine/core'
import { useForm, zodResolver } from '@mantine/form'
import Form from 'common/Form'
import { PasswordInput } from 'common/inputs/PasswordInput'
import { useRoles } from 'hooks/users'
import { newUserSchema } from 'types/schemas'
import { NewUser } from 'types/users'
import { trimFormValues } from 'utils'

type Props = {
  onSubmit: (values: NewUser) => void
  onCancel: () => void
}

export function AddUserForm({ onSubmit, onCancel }: Props) {
  const form = useForm<NewUser>({
    initialValues: {
      firstName: undefined!,
      lastName: undefined!,
      username: undefined!,
      password: undefined!,
      confirmPassword: undefined!,
      roles: [],
      active: true,
      allowedIPs: [],
    },
    validate: zodResolver(newUserSchema),
    transformValues: trimFormValues,
  })
  const { data: roles } = useRoles()

  return (
    <Form onSubmit={onSubmit} form={form} onCancel={onCancel} submitText="Dodaj użytkownika">
      <Stack gap="xs">
        <TextInput label="Imię" placeholder="Jan" withAsterisk {...form.getInputProps('firstName')} />
        <TextInput label="Nazwisko" placeholder="Kowalski" withAsterisk {...form.getInputProps('lastName')} />
        <TextInput label="Nazwa użytkownika" placeholder="jkowalski" withAsterisk {...form.getInputProps('username')} />
        <PasswordInput {...form.getInputProps('password')} />
        <MantinePasswordInput
          label="Powtórz hasło"
          placeholder="Twoje hasło"
          withAsterisk
          {...form.getInputProps('confirmPassword')}
        />

        <Switch.Group
          label="Role"
          description="Uprawnienia użytkownika"
          {...form.getInputProps('roles', { type: 'checkbox' })}
        >
          <Group mt="xs">
            {roles.map((role) => (
              <Switch key={role.id} value={role.id} label={role.name} />
            ))}
          </Group>
        </Switch.Group>
      </Stack>
    </Form>
  )
}
